const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");

/* NodeJS */
module.exports = {
  getLobbyRow: (propertyUid, lobbyRowId, language) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/lobby_row?language=${language}&property_uid=${propertyUid}&node_id=${lobbyRowId}`,
      })
    ),
};